const autoComplete = require('@tarekraafat/autocomplete.js')

document.addEventListener('DOMContentLoaded', initInvoiceAutocomplete)
document.addEventListener('turbolinks:load', initInvoiceAutocomplete)

function initInvoiceAutocomplete() {
  const invoiceCompanySelctor =
    "input[name='invoice[company]'][data-invoice-addresses-path][data-invoice-fill-keys]"
  const invoiceCompanyInput = document.querySelector(invoiceCompanySelctor)

  if (
    invoiceCompanyInput &&
    !invoiceCompanyInput.closest('.autoComplete_wrapper')
  ) {
    const invoiceFillKeys = JSON.parse(
      invoiceCompanyInput.dataset.invoiceFillKeys
    )

    const autoCompleteJS = new autoComplete({
      selector: invoiceCompanySelctor,
      data: {
        src: async () => {
          try {
            const source = await fetch(
              invoiceCompanyInput.dataset.invoiceAddressesPath
            )
            const data = await source.json()
            return data
          } catch (error) {
            return error
          }
        },
        keys: invoiceFillKeys,
        cache: true,
        filter: (list) => {
          return Object.values(
            list.reduce((acc, item) => {
              acc[item.value.id] = item
              return acc
            }, {})
          )
        },
      },
      resultsList: {
        element: (list, _data) => {
          autocompleteResizeList(list)
        },
        maxResults: 20,
      },
      resultItem: {
        element: (item, data) => {
          item.innerHTML = `
          <b>${data.value.company}</b>
          ${data.value.department ? `– ${data.value.department}` : ''}
          ${data.value.co ? `<br />${data.value.co}` : ''}
          ${data.value.address ? `<br />${data.value.address}` : ''}
          ${data.value.zip || data.value.city ? '<br />' : ''}
          ${data.value.zip} ${data.value.city}
        `
        },
      },
    })

    autoCompleteJS.input.addEventListener('selection', function (event) {
      const value = event?.detail?.selection?.value
      if (value) {
        const form = autoCompleteJS.input.closest('form')
        invoiceFillKeys.forEach((key) => {
          let input
          if (key == 'country') {
            input = form.querySelector(
              `select[name='country'], select[name='invoice[country]']`
            )
          } else {
            input = form.querySelector(`input[name='invoice[${key}]']`)
          }
          if (input) {
            input.value = value[key]
            input.dispatchEvent(new Event('change', { bubbles: true }))
          }
        })
        hidden = form.querySelector(`input[name='invoice[invoice_address_id]']`)
        if (hidden) {
          hidden.value = value.id
        }
      }
    })

    window.addEventListener('resize', () => {
      autocompleteResizeList(autoCompleteJS?.list)
    })

    window.addEventListener('scroll', () => {
      autocompleteResizeList(autoCompleteJS?.list)
    })

    document.querySelector('.main-content')?.addEventListener('scroll', () => {
      autocompleteResizeList(autoCompleteJS?.list)
    })
  }
}

function autocompleteResizeList(list) {
  const wrapper = list?.closest('.autoComplete_wrapper')
  if (wrapper) {
    const rect = wrapper.getBoundingClientRect()
    list.style.maxHeight = `${window.innerHeight - rect.bottom - 10}px`
  }
}
